import FadeIn from "../components/FadeIn";
import { ME } from "../constants/portfolioData";

/**
 * HeroSection
 * Full-height landing section with name, title, summary, CTAs, and highlight chips.
 * @param {function} scrollTo - scroll to a section by id
 */
const HeroSection = ({ scrollTo }) => {
  return (
    <>
      <style>{`
        #home { padding-top: 9rem; padding-bottom: 5rem; min-height: 100vh; display: flex; flex-direction: column; justify-content: center; }
        .avail-badge { display: inline-flex; align-items: center; gap: 0.5rem; background: var(--green-dim); border: 1px solid #22c55e44; color: var(--green); border-radius: 100px; padding: 0.3rem 0.9rem 0.3rem 0.5rem; font-family: 'IBM Plex Mono', monospace; font-size: 0.75rem; margin-bottom: 2rem; }
        .badge-pulse { width: 7px; height: 7px; background: var(--green); border-radius: 50%; animation: pulse 2s infinite; flex-shrink: 0; }
        @keyframes pulse { 0%,100%{opacity:1;transform:scale(1)} 50%{opacity:.5;transform:scale(1.4)} }
        .hero-name { font-family: 'IBM Plex Sans', sans-serif; font-size: clamp(3rem, 7vw, 5.5rem); font-weight: 700; color: var(--text); letter-spacing: -0.04em; line-height: 1.0; margin-bottom: 0.75rem; }
        .hero-title-line { font-family: 'IBM Plex Mono', monospace; font-size: clamp(0.9rem, 1.8vw, 1.1rem); color: var(--muted); margin-bottom: 1.75rem; display: flex; align-items: center; gap: 0.75rem; }
        .title-sep { color: var(--border2); }
        .hero-summary { font-family: 'IBM Plex Sans', sans-serif; font-size: 1.05rem; max-width: 600px; line-height: 1.85; color: var(--muted2); margin-bottom: 2.5rem; }
        .hero-actions { display: flex; flex-wrap: wrap; gap: 0.75rem; margin-bottom: 3rem; }
        .highlight-row { display: flex; flex-wrap: wrap; gap: 0.6rem; }
        .hl-chip { display: inline-flex; align-items: center; gap: 0.4rem; padding: 0.3rem 0.75rem; background: var(--bg3); border: 1px solid var(--border2); border-radius: 6px; font-family: 'IBM Plex Mono', monospace; font-size: 0.75rem; color: var(--muted2); }
        .hl-chip::before { content: '→'; color: var(--accent); font-size: 0.7rem; }
      `}</style>

      <section id="home">
        <div className="wrap">
          <FadeIn>
            {ME.available && (
              <div className="avail-badge">
                <span className="badge-pulse" />
                Open to Senior / Staff Backend roles
              </div>
            )}
          </FadeIn>

          <FadeIn delay={0.1}>
            <h1 className="hero-name">{ME.name}</h1>
          </FadeIn>

          <FadeIn delay={0.2}>
            <div className="hero-title-line">
              <span>{ME.title}</span>
              <span className="title-sep">/</span>
              <span>{ME.location}</span>
            </div>
          </FadeIn>

          <FadeIn delay={0.3}>
            <p className="hero-summary">{ME.summary}</p>
          </FadeIn>

          <FadeIn delay={0.4}>
            <div className="hero-actions">
              <a
                href="#contact"
                className="btn-p"
                onClick={(e) => { e.preventDefault(); scrollTo("contact"); }}
              >
                Let's Talk →
              </a>
              <a href={ME.resumeUrl} className="btn-s" target="_blank" rel="noreferrer">
                View Resume ↗
              </a>
              <a href={ME.github} className="btn-s" target="_blank" rel="noreferrer">
                GitHub ↗
              </a>
              <a href={ME.linkedin} className="btn-s" target="_blank" rel="noreferrer">
                LinkedIn ↗
              </a>
            </div>
          </FadeIn>

          <FadeIn delay={0.5}>
            <div className="highlight-row">
              {ME.highlights.map((h) => (
                <span key={h} className="hl-chip">{h}</span>
              ))}
            </div>
          </FadeIn>
        </div>
      </section>
    </>
  );
};

export default HeroSection;